import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const reviewApi = createApi({
    reducerPath: 'reviewApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getRegions: builder.query<string[], void>({
            query: () => ({ url: `/mail/regions` })
        }),
        sendFormData: builder.mutation<string[], any>({
            query: body => ({ url: `/mail/feedback`, method: 'POST', body: body })
        }),
        sendManagerFeedback: builder.mutation<
            any,
            { manager: number; name: string; email: string; phone: string; message: string; product: string }
        >({
            query: data => {
                const manager = data?.manager
                delete data.manager
                return { url: `/mail/manager/send-feedback/${manager}`, method: 'POST', body: data }
            }
        })
    })
})

export const { useGetRegionsQuery, useSendFormDataMutation, useSendManagerFeedbackMutation } = reviewApi
